module.exports = __webpack_public_path__ + "static/media/passengers-unrecommended.d576b422.svg";